export const environment = {
    production: false,
    apiBaseUrl: 'https://dev-api.zentility.com',
    storageSecretKey: '9d5657b7-69b6-4815-9760-fe875b411d89', // Some random online generated UUID
    siteKey: '6LfF5l0UAAAAAAPEtagoNGSmXsMXHTZKI7bT2Jp2',
    signApiBaseUrl: 'https://dev-sign-api.zentility.com',
};
